export default {
  NONE: 0,      // なし
  MONITOR: 1,   // 監視
  CONFIGURE: 2, // 設定
  OPERATE: 3,   // 操作
}
